import {
  FETCH_STOCKS_REQUEST,
  FETCH_STOCKS_SUCCESS,
  FETCH_STOCKS_FAILURE,
  CREATE_STOCK,
  UPDATE_STOCK,
  DELETE_STOCK,
} from '../../types/stock/stockTypes';

const initialState = {
  stocks: [],
  loading: false,
  error: null,
};

const stockReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STOCKS_REQUEST:
      return { ...state, loading: true };

    case FETCH_STOCKS_SUCCESS:
      return { ...state, loading: false, stocks: action.payload };

    case FETCH_STOCKS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    
    case CREATE_STOCK:
  return {
    ...state,
    stocks: [...state.stocks, action.payload],
  };

    case DELETE_STOCK:
      return {
        ...state,
        stocks: state.stocks.filter((d) => d.id !== action.payload),
      };

    case UPDATE_STOCK:
      return {
        ...state,
        stocks: state.stocks.map((d) =>
          d.id === action.payload.id ? { ...d, ...action.payload.data } : d
        ),
      };

    default:
      return state;
  }
};

export default stockReducer;
